module.exports = __webpack_public_path__ + "img/48740351015359.36cd74bf.png";